// extracted by mini-css-extract-plugin
export default {"main":"landing_main__AIAV-","landing":"landing_landing__tq6W2","footer":"landing_footer__i-6Ye"};